import { CompensationDeviationTendancy } from '../enums/compensation-deviation-tendancy.enum';

export interface CompensationDeviationWarningContext {
  /** individual compensation deviation; male distribution >= 0, female distribution <= 0 */
  distribution: number;
  /** compa-ratio of the current compensation against the benchmark mid value, in percent */
  currentCompaRatio: number;
  /** absolute Total Target Cash increase granted in this allocation */
  ttcIncrease: number;
}

export class CompensationDeviationHelper {
  public static getTendency(distribution: number): CompensationDeviationTendancy | undefined {
    if (distribution == null) {
      return undefined;
    }

    if (distribution < -2.5) {
      return CompensationDeviationTendancy.HugeGapBelow;
    }
    if (distribution < -1.25) {
      return CompensationDeviationTendancy.SmallGapBelow;
    }
    if (distribution <= 0) {
      return CompensationDeviationTendancy.InExpectationBelow;
    }
    if (distribution <= 1.25) {
      return CompensationDeviationTendancy.InExpectationAbove;
    }
    if (distribution <= 2.5) {
      return CompensationDeviationTendancy.SmallGapAbove;
    }
    return CompensationDeviationTendancy.HugeGapAbove;
  }

  public static getWarningTranslationKey({
    distribution,
    currentCompaRatio,
    ttcIncrease
  }: CompensationDeviationWarningContext): string | undefined {
    if (currentCompaRatio == null) {
      return undefined;
    }

    switch (this.getTendency(distribution)) {
      case CompensationDeviationTendancy.SmallGapBelow:
      case CompensationDeviationTendancy.HugeGapBelow:
        return currentCompaRatio < 100 ? 'merit-budget.hr-research.compensation-deviation.warning-below' : undefined;
      case CompensationDeviationTendancy.SmallGapAbove:
      case CompensationDeviationTendancy.HugeGapAbove:
        return currentCompaRatio > 100 && ttcIncrease > 0
          ? 'merit-budget.hr-research.compensation-deviation.warning-above'
          : undefined;
      default:
        return undefined;
    }
  }
}
